import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M6.40003 3.16406C5.55193 2.69375 4.49818 3.29081 4.49988 4.24068L4.52765 19.7636C4.52935 20.7134 5.58492 21.3069 6.43132 20.834L20.3618 13.0515C21.2142 12.5753 21.2122 11.3781 20.3582 10.9045L6.40003 3.16406ZM8.20306 17.0795C7.34212 17.5557 6.27711 16.9332 6.30469 15.9699L6.30821 15.847C6.32069 15.4109 6.56838 15.0135 6.96003 14.8011L10.2537 13.0153C11.1212 12.545 11.1241 11.3317 10.2589 10.8574L6.93766 9.03705C6.55437 8.82697 6.31441 8.43477 6.30729 8.00676C6.29177 7.07431 7.32398 6.47893 8.15717 6.93975L15.403 10.9473C16.2602 11.4214 16.2602 12.6235 15.403 13.0976L8.20306 17.0795Z' />
        </SvgIcon>
    );
});
